module.exports = __webpack_public_path__ + "static/media/img-value-window.7ab6c0c5.png";